import { t } from '../../../localization';
import fieldNames from '../constants/field-names';
import { isEmail, isPhone, isURL } from '../../../common/validations';

const getTextFieldRules = (required = true, minLength = 20, maxLength = 1000) => ({
  minLength: {
    value: minLength,
    message: t('Requires at least {length} characters', {
      length: minLength,
    }),
  },
  maxLength: {
    value: maxLength,
    message: t('Maximum {length} characters', {
      length: maxLength,
    }),
  },
  required: required && t('This field is required'),
});

const getUrlRules = () => ({
  required: t('This field is required'),
  validate: (value) => (value && !isURL(value) ? t('Please enter a valid URL') : null),
});

const getEmailRules = () => ({
  required: t('This field is required'),
  validate: (value) =>
    value && !isEmail(value) ? t('Invalid email. Please, check the email and try again') : null,
});

const getPhoneRules = () => ({
  required: t('This field is required'),
  validate: (value) =>
    value && !isPhone(value)
      ? t('Invalid phone number. Please, check the phone number and try again')
      : null,
});

const getRequiredRules = () => ({
  required: t('This field is required'),
});

const getValidationRules = () => ({
  [fieldNames.SERVICE]: {
    required: t('Please select a project type'),
  },
  [fieldNames.NEW_WEBSITE_DESCRIPTION]: getTextFieldRules(),
  [fieldNames.NEW_WEBSITE_CONTENT]: getRequiredRules(),
  [fieldNames.NEW_WEBSITE_CONTENT_OTHER_TYPE]: getTextFieldRules(false, 0),
  [fieldNames.NEW_WEBSITE_EXPECTED_FEATURES]: getTextFieldRules(false, 0),
  [fieldNames.WEBSITE_DESCRIPTION]: getTextFieldRules(),
  [fieldNames.WEBSITE_EXPECTED_IMPROVEMENTS]: getTextFieldRules(),
  [fieldNames.MIGRATION_PLATFORM_OTHER]: getTextFieldRules(true, 0),
  [fieldNames.MIGRATION_REASON_OTHER]: getTextFieldRules(true, 0),
  [fieldNames.MIGRATION_WEBSITE_URL]: getUrlRules(),
  [fieldNames.MIGRATION_PLATFORM]: getRequiredRules(),
  [fieldNames.MIGRATION_REASON]: getRequiredRules(),
  [fieldNames.MIGRATION_EXPECTED_IMPROVEMENTS]: getTextFieldRules(),
  [fieldNames.CONTACT_INFO_USER_FULL_NAME]: getRequiredRules(),
  [fieldNames.CONTACT_INFO_USER_EMAIL]: getEmailRules(),
  [fieldNames.CONTACT_INFO_USER_PHONE]: getPhoneRules(),
});

export default getValidationRules;
